import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  flex: 1;
  padding: 0 70px;
`;
